/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_StorageInputs */

const en_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage Capacity`)
};

const es_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad de almacenamiento`)
};

const fr_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité de stockage`)
};

const de_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherkapazität`)
};

const ja_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストレージ容量`)
};

const zh_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储容量`)
};

const ar_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعة التخزين`)
};

const id_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas Penyimpanan`)
};

const it_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacità di Archiviazione`)
};

const ru_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Емкость памяти`)
};

const pt_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade de Armazenamento`)
};

const ko_field_storage = /** @type {(inputs: Field_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장 용량`)
};

/**
* | output |
* | --- |
* | "Storage Capacity" |
*
* @param {Field_StorageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_storage = /** @type {((inputs?: Field_StorageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_StorageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_storage(inputs)
	if (locale === "es") return es_field_storage(inputs)
	if (locale === "fr") return fr_field_storage(inputs)
	if (locale === "de") return de_field_storage(inputs)
	if (locale === "ja") return ja_field_storage(inputs)
	if (locale === "zh") return zh_field_storage(inputs)
	if (locale === "ar") return ar_field_storage(inputs)
	if (locale === "id") return id_field_storage(inputs)
	if (locale === "it") return it_field_storage(inputs)
	if (locale === "ru") return ru_field_storage(inputs)
	if (locale === "pt") return pt_field_storage(inputs)
	return ko_field_storage(inputs)
});